<template lang="pug">
#events
  .page-controls
    b-field(grouped)
      b-field(expanded)
        media-search(
          :indexes="indexes"
          :placeholder="`Filter ${activeTabLabel}...`"
          @select="addTag"
        )
      p.control
        b-select(
          v-if="activeTabLabel !== 'waivers'"
          :value="filters.pub"
          @input="setFilter($event, 'pub')"
        )
          option(value="all") All
          option(value="published") Published
          option(value="draft") Draft
      p.control(v-if="activeTabLabel === 'events'")
        b-select(
          :value="filters.status"
          @input="setFilter($event, 'status')"
        )
          option(value="all") All
          option(value="current") Current
          option(value="past") Past
      p.control
        button.button.is-success(@click="newModal")
          b-icon(icon="plus")
          span {{ newButtonLabel }}
    filter-tags(mode="events")
  b-tabs.page-tabs(
    position="is-centered"
    v-model="activeTab"
    :animated="false"
    @change="changeTab"
  )
    b-tab-item(label="Events")
      events-tab(type="event")
    b-tab-item(label="Special Projects")
      events-tab(type="project")
    b-tab-item(label="Waivers")
      waivers-tab
</template>

<script>
import { mapGetters } from 'vuex';
import EventForm from '@/components/form/EventForm';
import EventsTab from '@/components/EventsTab';
import FilterTags from '@/components/FilterTags';
import MediaSearch from '@/components/MediaSearch';
import PubTag from '@/components/PubTag';
import Spinner from '@/components/Spinner';
import WaiverForm from '@/components/form/WaiverForm';
import WaiversTab from '@/components/WaiversTab';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'events',
  components: {
    EventForm,
    EventsTab,
    FilterTags,
    MediaSearch,
    PubTag,
    Spinner,
    WaiversTab,
  },
  computed: {
    ...mapGetters({
      filters: getters.GET_EVENT_FILTERS,
      refresh: getters.GET_EVENTS_REFRESH,
    }),
    activeTabLabel() {
      return this.tabs[this.activeTab];
    },
    newButtonLabel() {
      let label;
      switch (this.activeTabLabel) {
        case 'events':
          label = 'Event';
          break;
        case 'projects':
          label = 'Project';
          break;
        case 'waivers':
          label = 'Waiver';
          break;
        default:
      }
      return `New ${label}`;
    },
  },
  created() {
    if (this.tab) this.activeTab = this.tab;
  },
  data() {
    return {
      activeTab: 0,
      indexes: [
        'doxa_events',
        'doxa_ministries',
      ],
      searchResults: [],
      tabs: [
        'events',
        'projects',
        'waivers',
      ],
    };
  },
  methods: {
    addTag(tag) {
      this.$store.commit(mutations.TOGGLE_EVENTS_TAG, tag);
      this.$store.commit(mutations.SET_EVENTS_REFRESH, true);
    },
    changeTab(index) {
      this.$store.commit(mutations.SET_EVENT_FILTER_FIELD, {
        key: 'sort.field',
        val: this.tabs[index] === 'events' ? 'end_date' : 'sort_order',
      });
      this.$router.push({ name: 'events', query: { tab: index } });
    },
    newModal() {
      if (this.activeTabLabel === 'waivers') {
        this.$store.commit(mutations.UNSET_WAIVER);
        this.$buefy.modal.open({
          parent: this,
          component: WaiverForm,
          hasModalCard: true,
        });
      } else {
        this.$store.commit(mutations.UNSET_EVENT);
        this.$store.commit(mutations.SET_EVENT_FIELD, {
          key: 'type',
          val: this.activeTabLabel.slice(0, -1),
        });
        this.$buefy.modal.open({
          parent: this,
          component: EventForm,
          hasModalCard: true,
        });
      }
    },
    setFilter(val, key) {
      this.$store.commit(mutations.SET_EVENT_FILTER_FIELD, {
        key,
        val,
      });
      this.$store.commit(mutations.SET_EVENTS_REFRESH, true);
    },
  },
  props: ['tab'],
};
</script>

<style lang="scss">
#events {
  .level {
    padding-right: 1rem;
  }
  table.table {
    tbody {
      tr {
        cursor: pointer;
        height: 45px;
        .drag-icon {
          cursor: move;
        }
        a {
          small {
            //text-decoration: underline;
          }
        }
        .sign-up-actions.level {
          padding-bottom: 0;
          .level-item {
            a {
              display: flex;
              align-items: center;
              .icon {
                margin-right: 0.35rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Events.vue